<template>
  <el-dialog
    class="rc-dialog"
    :title="msgTitle"
    :visible.sync="addDialog.flag"
    width="40%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="180px"
      :rules="rules"
      :model="trainForm"
      ref="trainForm"
      >
      <el-row>
        <el-col :span="18">
          <el-form-item label="视频中出现的人物姓名：" prop="includeUserName">
            <el-input
              v-model="trainForm.includeUserName"
              placeholder="请输入视频中出现的人物姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="视频人物单位及职务：" prop="includeUnitPosition">
            <el-input
              v-model="trainForm.includeUnitPosition"
              placeholder="请输入视频人物单位及职务"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="籍贯：" prop="includeNativePlace">
            <el-input
              v-model="trainForm.includeNativePlace"
              placeholder="请输入视频人物籍贯"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="出现类型：" prop="includeType">
            <el-select
              v-model="trainForm.includeType"
              placeholder="请选择出现类型"
              style="width:100%"
              @change="changeIncludeType"
            >
              <el-option
                v-for="item in includeTypeList"
                :key="Number(item.paramKey)"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="出现时间：" prop="includeTime">
            <el-input
              v-model="trainForm.includeTime"
              placeholder="请输入出现时间"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import { saveCourseClass, updateCourseClass, getCourseClassInfo, classRoomPage } from "@/api/class";
import rulesFactory from "@/utils/rules";
export default {
  components: {},
  props: {
    classId: {
      type: String,
      default: () => null
    },
    index: {
      type: Number,
      default: () => -1
    },
    addDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
          isEdit: false,
          editItem: {}
        };
      },
    }
  },
  data() {
    return {
      more: true,
      page: 1,
      data: [],
      isSetInit: true,
      rulesFactory,
      msgTitle: "新增/编辑审查内容",
      trainForm: {
        includeUserName: "",
        includeUnitPosition: "",
        includeNativePlace: "",
        includeType: "",
        includeTypeName: "",
        includeTime: "",
      },
      includeTypeList: [],
      rules: {
        includeUserName: [rulesFactory.required("请输入视频中出现的人物姓名"), rulesFactory.size("最多输入30个字", 0, 30)],
        includeUnitPosition: [rulesFactory.required("请输入视频人物单位及职务"), rulesFactory.size("最多输入255个字", 0, 255)],
        // includeNativePlace: [rulesFactory.required("请输入视频人物籍贯"), rulesFactory.size("最多输入30个字", 0, 30)],
        includeType: [{ required: true, message: "请选择出现类型" }],
        includeTime: [rulesFactory.required("请输入出现时间"), rulesFactory.size("最多输入30个字", 0, 30)],
      },
    };
  },
  created() {
    if (this.addDialog.isEdit) {
      this.trainForm = this.addDialog.editItem;
    } else this.initForm();
    this.getSysParamByTypes(["VIDEO_INCLUDE_INFO_TYPE"]);
  },
  methods: {
    cancel() {
      this.$emit("closeAddDialog");
    },
    initForm() {
      this.trainForm = {
        includeUserName: "",
        includeUnitPosition: "",
        includeNativePlace: "",
        includeType: "",
        includeTypeName: "",
        includeTime: "",
      }
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.includeTypeList = res.data["VIDEO_INCLUDE_INFO_TYPE"];
      });
    },
    changeIncludeType(val) {
      let item = this.includeTypeList.filter((item) => Number(item.paramKey) == val)[0];
      this.trainForm.includeTypeName = item.paramValue;
    },
    // 保存
    submit() {
      this.$refs["trainForm"].validate().then(() => {
        this.$emit("addSucceed", this.trainForm);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    padding-bottom: 40px;
    .form-select {
      width: 80%;
    }
  }
}
</style>